<template>
  <div>
    <v-app-bar v-if="!esEscritorio" color="primary" density="comfortable">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="text-truncate">{{ nombreGimnasio }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="salir">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      :permanent="esEscritorio"
      :temporary="!esEscritorio"
      width="264"
      class="barra-lateral"
    >
      <div class="d-flex align-center pa-4" style="gap: 12px; border-bottom: 1px solid rgba(255, 255, 255, 0.08)">
        <v-avatar size="38" rounded="lg" color="white">
          <v-img v-if="logo" :src="urlImagen(logo)" alt="Logo"></v-img>
          <v-icon v-else color="primary">mdi-dumbbell</v-icon>
        </v-avatar>
        <div class="d-flex flex-column" style="min-width: 0">
          <span class="text-body-2 font-weight-bold text-white text-truncate">{{ nombreGimnasio }}</span>
          <span class="text-caption" style="color: #7c93ac">Panel de administración</span>
        </div>
      </div>

      <v-list nav density="compact" class="px-3 py-4">
        <v-list-item
          v-for="item in items"
          :key="item.title"
          :to="item.link"
          :title="item.title"
          rounded="lg"
          class="mb-1 item-nav"
          color="#7CC3FF"
          base-color="#AEC2D6"
        >
          <template v-slot:prepend>
            <v-icon>{{ item.icon }}</v-icon>
          </template>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <div class="d-flex align-center pa-4" style="gap: 10px; border-top: 1px solid rgba(255, 255, 255, 0.08)">
          <v-avatar size="34" color="primary">
            <span class="text-caption font-weight-bold text-white">{{ iniciales }}</span>
          </v-avatar>
          <div class="flex-grow-1 text-truncate">
            <div class="text-caption font-weight-medium text-white text-truncate">{{ nombreUsuario }}</div>
          </div>
          <v-btn icon="mdi-logout" size="small" variant="text" color="#7C93AC" @click="salir"></v-btn>
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>
<script>
import Utiles from '../Servicios/Utiles'
export default {
  name: "Encabezado",

  data: () => ({
    drawer: false,
    nombreUsuario: "",
    nombreGimnasio: "",
    logo: "",
    items: [
      { title: "Inicio", icon: "mdi-view-dashboard", link: "/" },
      { title: "Registrar visita", icon: "mdi-home-account", link: "/registrar-visita" },
      { title: "Usuarios", icon: "mdi-account-box", link: "/usuarios" },
      { title: "Miembros", icon: "mdi-weight-lifter", link: "/miembros" },
      {
        title: "Membresías",
        icon: "mdi-wallet-membership",
        link: "/membresias",
      },
      { title: "Pagos", icon: "mdi-account-cash", link: "/pagos" },
      { title: "Visitas", icon: "mdi-calendar-star", link: "/visitas" },
      { title: "Configurar", icon: "mdi-cog", link: "/configurar" },
      { title: "Mi perfil", icon: "mdi-account-key", link: "/perfil" },
    ],
  }),

  computed: {
    esEscritorio() {
      return this.$vuetify.display.mdAndUp;
    },

    iniciales() {
      if (!this.nombreUsuario) return "";
      return this.nombreUsuario
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((parte) => parte[0].toUpperCase())
        .join("");
    },
  },

  mounted(){
    this.nombreUsuario = localStorage.getItem("nombreUsuario")
    this.nombreGimnasio = localStorage.getItem("nombreGimnasio")
    this.logo = localStorage.getItem("logoGimnasio")
    this.drawer = this.esEscritorio

  },

  methods:{
    salir(){
      localStorage.removeItem('logeado')
      localStorage.removeItem('nombreUsuario')
      localStorage.removeItem('idUsuario')
      localStorage.removeItem('token')
      window.location.reload()
    },

    urlImagen(imagen) {
      return Utiles.generarURL(imagen);
    },

  }
};
</script>
<style>
.barra-lateral {
  background-color: #0f2439 !important;
}

.barra-lateral .item-nav:hover {
  background: rgba(255, 255, 255, 0.06);
}

.barra-lateral .item-nav.v-list-item--active {
  background: rgba(255, 255, 255, 0.09);
  font-weight: 600;
  box-shadow: inset 3px 0 0 #7cc3ff;
}
</style>
